"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const moduleItem_1 = require("./moduleItem");
const moduleListContext_1 = require("./moduleListContext");
const moduleTooltip_1 = __importDefault(require("./moduleTooltip"));
const ModuleList = ({ modules, className, showClassesTooltip, productId, onModuleChange, onModulePageChange, onModuleCollapse }) => {
    return ((0, jsx_runtime_1.jsx)(moduleListContext_1.ModuleListProvider, { onModuleCollapse: onModuleCollapse, onModuleChange: onModuleChange, onModulePageChange: onModulePageChange, children: (0, jsx_runtime_1.jsx)("section", { className: className, children: modules.map((module, index) => {
                const isLast = modules.length === index + 1;
                return ((0, jsx_runtime_1.jsx)(moduleTooltip_1.default, { isEnabled: module.isDisabled, title: module.tooltipTitleKey, children: (0, jsx_runtime_1.jsx)(moduleItem_1.ModuleItem, { className: "_mb-4", module: module, showClassesTooltip: showClassesTooltip, productId: productId, isLast: isLast }) }, module.id));
            }) }) }));
};
exports.default = ModuleList;
